import { createContext } from 'react';

// When set (inside the Desktop Preview), AdminLayout renders as if the logged-in
// user had this role — the right sidebar/nav and landing — without changing the
// real session. Destructive footer actions (Sign out / Mobile view) are disabled
// while previewing so the preview can never touch the real login or view pref.
const PreviewRoleContext = createContext(null);
export default PreviewRoleContext;
